import { Negotiation } from '@/modules/negotiation/entities/interfaces/negotiation';
import { get } from 'lodash';

export const checkContainsProvider = (negotiation: Negotiation, arrayProviders: string[]) => {
  const providerName = get(negotiation, 'product.provider.name');
  return new RegExp(arrayProviders.join('|'), 'i').test(providerName);
};
